// export const API_HOST = "http://localhost:3005/api/v1/";

// export const API_HOST = "https://smartcheck.toothlens.com/api/v1/";

// export const API_HOST = "https://devhygiene.toothlens.com/api/v1/";

export const API_HOST = "https://selfcheck.toothlens.com/api/v1/";

// export const API_HOST = "https://devtesting.toothlens.com/api/v1/";


